import React from 'react'
import { UserAvatarProps } from './UserAvatar.model'
import classNames from 'classnames'
import styles from './UserAvatar.module.scss'
import { Icon } from '../../shared'
import { getV3ColorCssVariable } from '../../../design-system/colors_v3'

export const UserAvatar = React.forwardRef<HTMLDivElement, UserAvatarProps>(
  (
    {
      familyName,
      firstName,
      icon,
      theme = 'primary',
      size = 'large',
      selected = false,
      showStar = false,
      testId,
      onClick,
    },
    ref,
  ) => (
    <div
      className={classNames(styles.userAvatar, styles[theme], styles[size], {
        [styles.selectable]: onClick ? true : false,
        [styles.selected]: selected,
      })}
      onClick={onClick}
      ref={ref}
      data-test-id={testId}
    >
      {!icon && familyName && firstName ? (
        <span className={styles.initials}>
          {firstName.charAt(0).toUpperCase()}
          {familyName.charAt(0).toUpperCase()}
        </span>
      ) : (
        icon && (
          <Icon
            icon={icon}
            size="micro"
            color={
              theme === 'primary'
                ? getV3ColorCssVariable('shades', 'white')
                : getV3ColorCssVariable('shades', 'shade4')
            }
          />
        )
      )}
      {showStar && (
        <div className={styles.star}>
          <Icon icon="starFull" size="nano" color={getV3ColorCssVariable('primary', 'default')} />
        </div>
      )}
    </div>
  ),
)
